import React from "react";

const Privacypolicy = () => {
  return (
    <div className="px-4 mx-lg-5 px-lg-5">
      <div className="px-lg-3">
        <h3 className="text-center pb-4 pt-3">
          *Privacy Policy for The Elite Enterprise E-commerce Website*
        </h3>
        <p className="pb-2">Last Updated: [Date]</p>
        <p>
          At The Elite Enterprise, we are committed to protecting your privacy.
          This Privacy Policy outlines how we collect, use, disclose, and
          safeguard your personal information when you use our website and
          services. By using our website, you consent to the practices described
          in this policy.
        </p>
        <p>
          <h6 className="fw-bold ">*1. Information We Collect:*</h6>
          <h6 className="fw-bold  pt-2"> - *Personal Information:*</h6>
          We may collect personal information such as your name, address, email
          address, and phone number when you place an order or create an account
          on our website.
        </p>
        <p>
          <h6 className="fw-bold"> - *Payment Information:* </h6>To process your
          transactions, we collect payment details, including credit card
          information and billing address.
        </p>
        <p>
          <h6 className="fw-bold"> - *Device Information:* </h6>We may collect
          information about the device you use to access our website, including
          IP address, browser type, and operating system.
        </p>
        <p>
          <h6 className="fw-bold"> - *Usage Data:*</h6> We gather information
          about how you navigate and interact with our website, including pages
          visited, products viewed, and time spent on the site.
        </p>
        <p>
          <h6 className="fw-bold"> *2. How We Use Your Information:* </h6>
          <h6 className="fw-bold  pt-2">- *Order Processing:*</h6> We use your
          personal information to process and fulfill your orders, communicate
          order status, and provide customer support.
        </p>
        <p>
          <h6 className="fw-bold"> - *Personalization:* </h6>We may use your
          information to personalize your shopping experience, recommend
          products, and tailor promotions to your preferences.
        </p>
        <p>
          <h6 className="fw-bold"> - *Communication:* </h6>With your consent, we
          may send you promotional emails, newsletters, and updates about our
          products and services. You can opt out of these communications at any
          time.
        </p>
        <p>
          <h6 className="fw-bold"> - *Security:* </h6>
          We use collected information to enhance the security of our website,
          detect and prevent fraudulent activities, and protect against
          unauthorized access.
        </p>
        <p>
          <h6 className="fw-bold"> *3. Information Sharing:* </h6>We do not
          sell, trade, or otherwise transfer your personal information to third
          parties for marketing purposes. Your information may be shared with
          trusted third parties who assist us in operating our website,
          conducting business, or servicing you, as long as those parties agree
          to keep this information confidential.
        </p>
        <p>
          <h6 className="fw-bold"> *4. Data Security:* </h6>We implement a
          variety of security measures to maintain the safety of your personal
          information. Your payment information is encrypted using secure socket
          layer technology (SSL) and stored with AES-256 encryption.
        </p>
        <p>
          <h6 className="fw-bold"> *5. Your Choices:*</h6> You have the right to
          access, correct, or delete your personal information. You can manage
          your communication preferences by adjusting your account settings or
          unsubscribing from promotional emails.
        </p>
        <p>
          <h6 className="fw-bold">*6. Contact Information:* </h6>If you have any
          questions or concerns regarding our Privacy Policy, you can contact us
          at:
        </p>
        <p>
          <span className="fw-bold">- Email:</span>info@theeliteenterprise.in
        </p>
        <p>
          <span className="fw-bold">- Phone: </span>+91 98202 44338
        </p>
        <p>
          <h6 className="fw-bold"> *7. Changes to Privacy Policy:*</h6> We
          reserve the right to update and modify this Privacy Policy at any
          time. Changes will be effective immediately upon posting on our
          website. Please review this policy periodically for any updates.
        </p>
        <p className="pt-2">
          
          By using The Elite Enterprise website, you agree to the terms of this
          Privacy Policy. Your privacy is important to us, and we are dedicated
          to protecting your personal information.
        </p>
      </div>
    </div>
  );
};

export default Privacypolicy;
